// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'shield';

export const Component = () => (
  <path d='M22.594 1H2v10.776c0 2.394 1.102 4.933 3.352 7.662 2.251 2.73 4.55 4.119 6.945 4.119 2.394 0 4.694-1.389 6.944-4.119 2.251-2.73 3.353-5.268 3.353-7.662V1Zm-.958.958v9.818c0 2.155-1.054 4.501-3.113 7.04-2.107 2.538-4.167 3.783-6.226 3.783-2.06 0-4.119-1.245-6.178-3.783-2.107-2.539-3.161-4.886-3.161-7.04V1.958h18.678ZM4.92 12.255V4.448c0-.335.191-.526.527-.526h4.885c.335 0 .479.191.479.526 0 .336-.144.48-.48.48H5.928v7.327c0 1.484.718 3.113 2.155 4.789 1.39 1.724 2.826 2.586 4.215 2.586.335 0 .479.143.479.479 0 .335-.144.526-.48.526-1.676 0-3.351-.958-4.932-2.873-1.628-1.916-2.442-3.736-2.442-5.508Z' />
);

export const viewBox = '0 0 25 25';
